import {store} from "../store";

export const addremovefilters = (data) => {

    store.dispatch({
        type: 'manipulatefilters',
        payload: data,
    });
};


export const clearAllFilters = () => {

    store.dispatch({
        type: 'clearfilters',
        payload: [],
    });
};


export const updateFeedback = (id, moderatorfeedback, technicalFeedback) => (
    store.dispatch({
        type: 'UPDATE_FEEDBACK',
        payload: {id, moderatorfeedback, technicalFeedback},
    }));


export const populateAllChats = (data) => {

    store.dispatch({
        type: 'populateChats',
        payload: data,
    });
};


export const populateAllNLP = (data) => {

    store.dispatch({
        type: 'populateNLP',
        payload: data,
    });
};


export const populateChatUsage = (data) => {

    store.dispatch({
        type: 'populateChatUsage',
        payload: data,
    });
};


